var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "mx-auto d-flex align-center pa-3",
    staticStyle: {
      "position": "sticky",
      "top": "0",
      "z-index": "2",
      "max-width": "500px"
    }
  }, [_c('v-text-field', {
    staticClass: "white",
    attrs: {
      "outlined": "",
      "dense": "",
      "rounded": "",
      "hide-details": "",
      "clearable": "",
      "label": "Search",
      "value": _vm.search,
      "disabled": !!_vm.loadingProviderId
    },
    on: {
      "input": function (x) {
        return _vm.$emit('input-search', x);
      }
    }
  }), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "content-class": "max-height-80vh",
      "nudge-left": "10",
      "disabled": !!_vm.loadingProviderId
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on;
        return [_c('div', _vm._g({
          staticClass: "d-flex align-center ml-2",
          staticStyle: {
            "cursor": "pointer"
          }
        }, on), [_c('country-flag', {
          attrs: {
            "country": _vm.country
          }
        }), _c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiMenuDown)
          }
        })], 1)];
      }
    }])
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.SUPPORTED_COUNTRY_CODES, function (code) {
    return _c('v-list-item', {
      key: code,
      attrs: {
        "input-value": _vm.country == code
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('input-country', code);
        }
      }
    }, [_c('country-flag', {
      staticClass: "my-n1 ml-n1 mr-2 flex-shrink-0",
      staticStyle: {
        "transform": "scale(.8)"
      },
      attrs: {
        "country": code
      }
    }), _c('v-list-item-title', [_vm._v(_vm._s(_vm._f("country-name")(code)))])], 1);
  }), 1)], 1)], 1), _vm.COUNTRY_CODE != _vm.country ? _c('div', {
    staticClass: "text-center caption font-italic warning--text pa-3"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": "warning"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v(" These gift cards can only be redeemed in " + _vm._s(_vm._f("country-name")(_vm.country)) + " ")], 1) : _vm._e(), _vm.loadProductsStatus.pending ? _c('div', {
    staticClass: "d-flex justify-center align-center pa-3"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _vm.filtered.length ? [_c('v-row', {
    staticClass: "relative pt-3",
    staticStyle: {
      "z-index": "1"
    }
  }, _vm._l(_vm.filtered, function (p) {
    return _c('v-col', {
      key: p.id,
      attrs: {
        "cols": "6",
        "sm": "4",
        "md": "3"
      }
    }, [_c('v-card', {
      staticClass: "gc-border",
      attrs: {
        "dark": "",
        "hover": "",
        "loading": _vm.loadingProviderId == p._providerId,
        "disabled": _vm.loadingProviderId == p._providerId,
        "to": _vm.$routeAssign({
          params: {
            providerId: p._providerId
          }
        })
      }
    }, [_c('v-img', {
      attrs: {
        "aspect-ratio": 300 / 190,
        "src": p.img
      }
    })], 1), _c('div', {
      staticClass: "pt-1 overline short text-center"
    }, [_vm._v(_vm._s(p.name))])], 1);
  }), 1), _c('div', {
    staticClass: "mt-8 caption"
  }, [_vm._v("The merchants represented are not sponsors of the rewards or otherwise affiliated with Ellacard. The logos and other identifying marks attached are trademarks of and owned by each represented company and / or its affiliates. Please visit each company’s website for additional terms and conditions.")])] : _c('div', {
    staticClass: "overline short"
  }, [_vm._v(" No gift cards found ")])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }